export const LOCAL_STORAGE_KEYS = {
  PROJECT: 'project',
  DOCKET_PROJECT: 'multiDocketProject',
  /** Full project filter rows (label + id) for delivery docket list; API still uses id[] in store. */
  DOCKET_PROJECT_FILTER_SELECTION: 'docketProjectFilterSelection',
  SUPPLIER: 'supplier',
  TOKEN: 'token',
  REFRESH: 'refresh',
  TENANT: 'tenant',
  USER_ID: 'user_id',
  BILL_MISMATCH_ALERT: 'billMismatchAlertIgnored',
  PER_PAGE: 'per_page',
  PAGE_NUMBER: 'pageNumber',
  /** Per-user flag: first-login setup wizard completed or skipped */
  FIRST_LOGIN_SETUP_DONE: 'first_login_setup_done',
  DCT_FILTERS: 'dctFilters',
  SCHEDULAR_MODE: 'schedularMode',
  NEW_YEAR: 'newYear',
  DELIVERY_DOCKET_STATUS: 'deliveryDocketStatus',
  /** Flag marking the current tokens as belonging to a guest-user session. */
  IS_GUEST_SESSION: 'is_guest_session',

  // module level
  TIMESHEET_PROJECT_KEY: 'timesheetProject',
  TIMESHEET_START_DATE_KEY: 'timesheetStartDate',
  TIMESHEET_END_DATE_KEY: 'timesheetEndDate',
};
